<template>
    <div class="page-header">
        <div class="form-row header-style">
			<div class="form-group col-md-3" style="margin:0px">
				<h2 class="form-group header-title" style="margin:0px;">Sales Diagnostic</h2>
			</div>

			<div class = "col-md-6"></div>

			<div class="form-group col-md-2 search-block" style = "margin: 0px;">
				<input type="search" class="form-control search" id="search"  @keyup.enter="getFilterData()" v-model="searchFilterString" placeholder="Search By Asin"  />
			</div>
			<div class="form-group col-md-1 search-button" style="margin: 0px;">
				<button class="btn btn-primary " style="margin:0px !important" @click="getFilterData()">
						<i class="fa fa-search"></i> Search
				</button>
			</div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'SalesListHeader',
    data() {
        return {

        }
    },
	components:{

	},
    computed: {
		searchFilterString: {
			set(val) {
				this.$store.state.searchFilterString = val
			},
			get() {
				return this.$store.state.searchFilterString
			}
		},
    },
    methods: {
		getFilterData(){
			this.$emit("getList");
		}
    }
}
</script>

<style lang="scss">

</style>
